import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";

export type JobOfferForExpense =
  RouterOutputs["expense"]["getMyJobOffersForExpenses"][number];

/**
 * Hook to fetch job offers that the provider can submit expenses for.
 * Returns job offers where the provider has claimed at least one shift.
 */
export function useProviderJobOffers() {
  const trpc = useTRPC();

  const {
    data: jobOffers,
    isLoading,
    error,
    refetch,
  } = useQuery(trpc.expense.getMyJobOffersForExpenses.queryOptions());

  return {
    jobOffers: (jobOffers ?? []) as JobOfferForExpense[],
    isLoading,
    error,
    refetch,
  };
}
